export default __webpack_public_path__ + "static/media/Arch_Amazon-DynamoDB_16.4199000c.svg";